import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Sprite from '../../../Prototype/Sprite';
import {
    createScaleTween,
    getTweenProps,
    createAlphaTween,
    createRotationTween,
} from '../AnimationTweenHelper';
import { Point } from 'pixi.js';
import { AwaitIterators } from '../AnimationHelper';
import { Easing } from '@tweenjs/tween.js';

export class RewardBoostersNodeEffect extends AnimationClip {
    public *execute(): IterableIterator<number> {
        const greenHalo = GameObject.Instantiate(Sprite, {
            texture: 'green-halo',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0, 0),
        });

        const greenHaloScaleTween = createScaleTween({
            ...getTweenProps(greenHalo, this, new Point(1.2, 0.8)),
            duration: 800,
        });

        const greenHaloAlphaTween = createAlphaTween({
            ...getTweenProps(greenHalo, this, { alpha: 0 }),
            duration: 400,
            delay: 600,
        });

        const haloNodeRing = GameObject.Instantiate(Sprite, {
            texture: 'halo-node-ring',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0, 0),
        });

        greenHalo.addChild(haloNodeRing);

        const haloRingScaleTween = createScaleTween({
            ...getTweenProps(haloNodeRing, this, new Point(1.2, 1.2)),
            duration: 800,
            delay: 100,
        });

        this.gameObject.addChild(greenHalo);

        yield* AwaitIterators([
            this.startTween(greenHaloScaleTween),
            this.startTween(greenHaloAlphaTween),
            this.startTween(haloRingScaleTween),
            this.createFlair(greenHalo),
        ]);
        this.gameObject.destroy();
    }

    *createFlair(halo: GameObject): IterableIterator<number> {
        const nSparkles = 5;
        const step = (2 * Math.PI) / nSparkles;
        const tweens: IterableIterator<number>[] = [];

        for (let i = 0; i < nSparkles; i++) {
            const radio = i % 2 ? 40 : 30;
            const duration = i % 2 ? 600 : 400;
            const delay = i % 2 ? 100 : 200;

            const star = GameObject.Instantiate(Sprite, {
                texture: 'halo-node-flair',
                position: new Point(
                    Math.cos(i * step) * radio,
                    Math.sin(i * step) * radio
                ),
                anchor: new Point(0.5, 0.5),
                scale: new Point(0.5, 0.5),
                alpha: 0,
            });

            halo.addChild(star);

            const alphaTween = createAlphaTween({
                ...getTweenProps(star, this, { alpha: 0.8 }),
                duration,
                delay,
            });

            const rotationTween = createRotationTween({
                ...getTweenProps(star, this, 3),
                duration: 1500,
                easing: Easing.Linear.None,
            });

            tweens.push(
                ...[this.startTween(alphaTween), this.startTween(rotationTween)]
            );
        }

        yield* AwaitIterators(tweens);
    }
}
